<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GVdW3R/tc-custom/9780226667676.jpg?1722573305958" alt="This image is the cover for the book Operation Fly Trap"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Operation Fly Trap
      </h1>
      <p class="bookDescription body article font2">
        <p>In 2003, an FBI-led task force known as Operation Fly Trap attempted to dismantle a significant drug network in two Bloods-controlled, African American neighborhoods in Los Angeles. The operation would soon be considered an enormous success, noted for the precision with which the task force targeted and removed gang members otherwise entrenched in larger communities. In <i>Operation Fly Trap</i>, Susan A. Phillips questions both the success of this operation and the methods used to conduct it. Based on in-depth ethnographic research with Fly Trap participants, Phillips’s work brings together police narratives, crime statistics, gang cultural histories, and extensive public policy analysis to examine the relationship between state persecution and the genesis of violent social systems. <br/><br/> Crucial to Phillips’s contribution is the presentation of the voices and perspectives of both the people living in impoverished communities and the agents that police them. Phillips positions law enforcement surveillance and suppression as a critical point of contact between citizen and state. She tracks the bureaucratic workings of police and FBI agencies and the language, ideologies, and methods that prevail within them, and shows how gangs have adapted, seeking out new locations, learning to operate without hierarchies, and moving their activities more deeply underground. Additionally, she shows how the targeted efforts of task forces such as Fly Trap wreak sweeping, sustained damage on family members and the community at large. Balancing her roles as even-handed reporter and public scholar, Phillips presents multiple flaws within the US criminal justice system and builds a powerful argument that many law enforcement policies in fact nurture, rather than prevent, violence in American society. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan A. Phillips
      </h2>
      
      <p class="authorDescription body article"><B>Susan A. Phillips</B> is assistant professor of environmental analysis at Pitzer College. She is the author of <I>Wallbangin’: Graffiti and Gangs in L.A.</I>, also published by the University of Chicago Press.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a72355de